import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import authSlice from './slices/authSlice';
import customersSlice from './slices/customersSlice';
import filtersSlice from './slices/filtersSlice';
import loadingSlice from './slices/loadingSlice';
import orderSlice from './slices/orderSlice';
import productsSlice from './slices/productsSlice';
import promotionsSlice from './slices/promotionsSlice';
import testSlice from './slices/testSlice';
import usersSlice from './slices/usersSlice';

export const store = configureStore({
  reducer: {
    testSlice,
    loadingSlice,
    authSlice,
    usersSlice,
    customersSlice,
    filtersSlice,
    productsSlice,
    orderSlice,
    promotionsSlice
  },
});

export const useAppDispatch = () => useDispatch();
